<sh-table id="service-tickets-table">
  <sh-table-row slot="header" id="sp-table-header">
    <sh-table-head
      id="sp-header-created"
      min-width="170px"
      columns="5"
      (toggle)="
        toggleSort(
          'creationDate',
          $event.target.hasAttribute('sort-descending')
        )
      "
    >
      {{ 'spareParts.created' | translate }}
    </sh-table-head>
    <sh-table-head
      id="sp-header-ticket-number"
      min-width="156px"
      columns="9"
      (toggle)="
        toggleSort(
          'ticketNumber',
          $event.target.hasAttribute('sort-descending')
        )
      "
    >
      {{ 'spareParts.ticketNumber' | translate }}
    </sh-table-head>
    <sh-table-head
      id="sp-header-subject"
      min-width="213px"
      columns="12"
      (toggle)="
        toggleSort('description', $event.target.hasAttribute('sort-descending'))
      "
    >
      {{ 'spareParts.subject' | translate }}
    </sh-table-head>
    <sh-table-head
      id="sp-header-operational-state"
      min-width="176px"
      columns="10"
      (toggle)="
        toggleSort(
          'operationalState',
          $event.target.hasAttribute('sort-descending')
        )
      "
    >
      {{ 'spareParts.operationalState' | translate }}
    </sh-table-head>
    <sh-table-head
      id="sp-header-status"
      min-width="130px"
      columns="8"
      (toggle)="
        toggleSort('partStatus', $event.target.hasAttribute('sort-descending'))
      "
    >
      {{ 'spareParts.partStatus' | translate }}
    </sh-table-head>
  </sh-table-row>
  @for (ticket of tickets(); track ticket.creationDate + '-' + $index) {
    <sh-table-row class="status-color status-color--{{ ticket.statusColor }}">
      <sh-table-cell
        min-width="170px"
        columns="5"
        [class.no-expand-icon]="!(ticket?.parts?.length > 0)"
      >
        <div class="tagged-creation-date">
          <span [class.tag-close]="ticket.status === 'Closed'">
            {{ ticket.creationDate | localizedDate }}
          </span>
          <sh-badge
            *ngIf="ticket.status === 'Closed'"
            label="{{ ticket.status }}"
          ></sh-badge>
        </div>
      </sh-table-cell>
      <sh-table-cell min-width="156px" columns="9">
        <span class="ticket-number">
          <span>
            {{ ticket.ticketNumber }}
          </span>
          <sh-icon
            icon="copy-results-to-clipboard"
            aria-label="{{ 'spareParts.ariaLabel.copyClipboard' | translate }}"
            size="s"
            color="#7D7D7D"
            button
            (click)="clipboardService.copyToClipboard(ticket.ticketNumber)"
            (keydown.enter)="
              clipboardService.copyToClipboard(ticket.ticketNumber)
            "
            (keydown.space)="
              clipboardService.copyToClipboard(ticket.ticketNumber)
            "
          ></sh-icon>
        </span>
      </sh-table-cell>
      <sh-table-cell min-width="213px" columns="12">
        <span
          #ticketDescription
          class="ellipsis"
          matTooltip="{{ ticket.description }}"
          matTooltipClass="sp-service-ticket-tooltip"
          matTooltipPosition="above"
          [matTooltipDisabled]="!hasOverflow(ticketDescription)"
        >
          {{ ticket.description }}
        </span>
      </sh-table-cell>
      <sh-table-cell min-width="176px" columns="10">
        {{ ticket.operationalState ?? UNKNOWN }}
      </sh-table-cell>
      <sh-table-cell min-width="130px" columns="8">
        <app-part-status-info
          [partStatus]="ticket.partStatus"
        ></app-part-status-info>
      </sh-table-cell>
      @if (ticket?.parts?.length > 0) {
        <sh-table-row>
          <app-subtable
            [headers]="headersSubtable"
            [rows]="ticket.parts"
          ></app-subtable>
        </sh-table-row>
      }
    </sh-table-row>
  }
</sh-table>
